import { makeStyles } from "@material-ui/core";
import React from "react";
import { ChipField } from "react-admin";
import classnames from "classnames";
export const ConditionField = props => {
  const useStyles = makeStyles({
    success: { background: "seagreen", color: "white" },
    error: { background: "#C90C0F", color: "white" },
    note: { background: "#FFC107", color: "white" },
  });
  const classes = useStyles();

  if (props.record[props.source] === null) {
    return null;
  }

  const wichColored = props => {
    if (props.record?.successMessage == "Note") return classes.note;
    if (props.record?.isSuccess === true) return classes.success;
    return classes.error;
  };

  return (
    <ChipField className={classnames(wichColored(props))} {...props} source={props.displaySource || props.source} />
  );
};
